import CheckDepositModal from './CheckDepositModal';

export default CheckDepositModal;
